import React from "react";

export const CollaborationIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="19" viewBox="0 0 28 19" fill="none">
      <circle cx="18" cy="5" r="4.25" stroke="white" strokeWidth="1.5" />
      <path
        d="M9 18C9 15.6 11.16 12 18 12C24.84 12 27 15.6 27 18"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="6.81571" cy="3.91521" r="2.48099" stroke="white" strokeWidth="1.5" />
      <path
        d="M1 11.8772C1 10.3263 2.39579 8 6.81579 8C11.2358 8 12.6316 10.3263 12.6316 11.8772"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
